import { requestApi } from './Api';

export const getInvoice = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/public/invoice/get',
    params
  });

export const verifyInvoicePatient = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/public/invoice/verify',
    params
  });
